"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fbo_1 = __importDefault(require("./gl-utils/fbo"));
var GlCanvas = __importStar(require("./gl-utils/gl-canvas"));
var gl_canvas_1 = require("./gl-utils/gl-canvas");
var viewport_1 = __importDefault(require("./gl-utils/viewport"));
var automaton_2D_1 = __importDefault(require("./automaton-2D"));
var parameters_1 = __importDefault(require("./parameters"));
require("./page-interface-generated");
function main() {
    var glParams = {
        alpha: false,
        preserveDrawingBuffer: true,
    };
    if (!GlCanvas.initGL(glParams)) {
        return;
    }
    gl_canvas_1.gl.blendFunc(gl_canvas_1.gl.ONE, gl_canvas_1.gl.ONE_MINUS_SRC_ALPHA);
    Page.Canvas.showLoader(true);
    var needToAdjustSize = true;
    Page.Canvas.Observers.canvasResize.push(function () { return needToAdjustSize = true; });
    parameters_1.default.autorun = true;
    parameters_1.default.persistence = 0;
    var automaton = new automaton_2D_1.default();
    var lastIteration = automaton.iteration;
    function updateIterationPerSecIndicator() {
        Page.Canvas.setIndicatorText("iterations-per-sec", "" + (automaton.iteration - lastIteration));
        lastIteration = automaton.iteration;
    }
    window.setInterval(updateIterationPerSecIndicator, 1000);
    function updateIterationIndicator() {
        Page.Canvas.setIndicatorText("iteration", "" + automaton.iteration);
    }
    window.setInterval(updateIterationIndicator, 50);
    var forceUpdate = false;
    parameters_1.default.nextStepObservers.push(function () { return forceUpdate = true; });
    var firstDraw = true;
    var lastUpdate = 0;
    function mainLoop(time) {
        var update = automaton.needToUpdate || forceUpdate ||
            (parameters_1.default.autorun && (time - lastUpdate > parameters_1.default.updateWaitTime));
        if (update) {
            lastUpdate = time;
            automaton.update();
            forceUpdate = false;
        }
        if (update || automaton.needToRedraw) {
            fbo_1.default.bindDefault(gl_canvas_1.gl);
            if (needToAdjustSize) {
                GlCanvas.adjustSize();
                needToAdjustSize = false;
            }
            viewport_1.default.setFullCanvas(gl_canvas_1.gl);
            automaton.draw();
            if (firstDraw) {
                firstDraw = false;
                Page.Canvas.showLoader(false);
            }
        }
        requestAnimationFrame(mainLoop);
    }
    requestAnimationFrame(mainLoop);
}
main();
